import { render, staticRenderFns } from "./InquiryForm.vue?vue&type=template&id=3b2c2a3c&"
import script from "./InquiryForm.vue?vue&type=script&lang=js&"
export * from "./InquiryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports